/** Стиль-пак «pastel-serif» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'pastel-serif',
  shape: {
    radiusCard: 24, radiusOption: 16, radiusButton: 8, radiusImage: 16,
    borderWidth: 0, borderTone: 'none', selectionMode: 'border', shadow: 'soft',
  },
  density: { optionHeight: 60, optionPadY: 16, optionPadX: 20, gap: 16, contentMaxWidth: 560, screenPadX: 20 },
  type: {
    headingFamily: 'serif', h1Size: 48, h1Weight: 400, h1Tracking: 0,
    qSize: 28, qWeight: 400, qTracking: 0, optionSize: 16, optionWeight: 400,
    headingAlign: 'left', overlineTransform: 'none',
  },
  chrome: { progress: 'bar', progressLabel: 'left', counter: false, backButton: 'icon-bare', logo: 'left' },
  cta: { placement: 'inline', fullWidth: false, height: 60, disabledStyle: 'grey' },
  states: { selected: 'brand-border-tint', hoverTint: true, transitionMs: 200, screenFadeMs: 0 },
  imagery: {
    optionCard: 'label-below', overlayTone: 'none', frame: 'rounded',
    promptHint: 'soft pastel lifestyle photo, warm natural light, gentle mood',
  },
  // BlossomUp/Welcome Baby: мягкое фото сверху, крупная антиква и inline-CTA
  // под ним слева (type.headingAlign 'left'); лёгкий нижний градиент не
  // съедает пастель, в отличие от ровной вуали.
  layout: { alignY: 'bottom', alignX: 'left', backgroundOverlay: 'scrim-bottom' },
  // BlossomUp: мягкий пак ведёт за руку — видны все стадии, процент как
  // обещание близкого финала и ободряющий отзыв под ним.
  loader: {
    style: 'all-stages', showPercent: true, socialProof: 'review',
    answersSummary: false, engagementModals: true,
  },
  // BlossomUp: мягкий пак не давит — цифры с подписями вместо мигающего
  // моно-счётчика, скидка плоской плашкой, помесячная цена, шапка-крышка.
  // Длинная пастельная страница заканчивается повторным блоком покупки.
  paywall: {
    timer: 'digits-labeled', promoTicket: 'plain', priceMode: 'per-month',
    planHighlight: 'cap-header', dimUnselectedPlans: false,
    stickyHeader: false, repeatPurchaseBlock: true,
  },
  // Пастель держит две мягкие роли: зелёный — гарантия и экономия, тёплый
  // вторичный акцент — премиальность.
  accents: { money: 'success', premium: 'accent' },
};
